import { useState } from 'react';
import { Link } from 'react-router-dom';
import { exclusiveNews } from '@/mocks/news';

export default function ExclusiveSection() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const item = exclusiveNews[currentIndex];

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev === 0 ? exclusiveNews.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev === exclusiveNews.length - 1 ? 0 : prev + 1));
  };

  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-8 md:gap-12">
          <div className="lg:w-[40%] flex-shrink-0">
            <Link to="/" className="block rounded-2xl overflow-hidden aspect-[4/5] bg-background-200 group">
              <img
                src={item.imageUrl}
                alt={`${item.title}${item.titleHighlight}`}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </Link>
          </div>

          <div className="lg:w-[60%] flex flex-col justify-center">
            <span className="text-xs font-label text-secondary-400 tracking-widest mb-4">
              （ 重磅独家 ）
            </span>
            <Link to="/" className="group">
              <h3 className="font-heading text-2xl md:text-3xl lg:text-4xl font-black leading-tight mb-8">
                <span className="text-foreground-950">{item.title}</span>
                <br />
                <span className="text-secondary-500 group-hover:text-primary-500 transition-colors duration-200">{item.titleHighlight}</span>
              </h3>
            </Link>
            <blockquote className="text-base md:text-lg text-foreground-600 leading-relaxed mb-6 pl-4 border-l-2 border-primary-500/30">
              &ldquo;{item.quote}&rdquo;
            </blockquote>
            <p className="text-sm font-heading font-bold text-foreground-700">
              &mdash; {item.source}
            </p>

            <div className="flex items-center gap-3 mt-8">
              <button
                onClick={handlePrev}
                className="w-10 h-10 flex items-center justify-center rounded-full border border-background-300 text-foreground-600 hover:text-foreground-950 hover:border-foreground-700 transition-all duration-200"
                aria-label="上一篇"
              >
                <i className="ri-arrow-left-line"></i>
              </button>
              <button
                onClick={handleNext}
                className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-500 text-foreground-950 hover:bg-primary-600 transition-colors duration-200"
                aria-label="下一篇"
              >
                <i className="ri-arrow-right-line"></i>
              </button>
              <Link
                to="/"
                className="ml-3 text-sm text-primary-500 hover:text-primary-400 transition-colors duration-200 font-label whitespace-nowrap"
              >
                阅读全文 <i className="ri-arrow-right-line ml-1 text-xs"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}